<script lang="ts">
    import { onMount } from "svelte";
    import { goto } from "$app/navigation";

    onMount(() => {
        goto("/");
    });
</script>

<svelte:head>
    <meta http-equiv="refresh" content="0; url=/" />
</svelte:head>
